import React from 'react';
import styled from 'styled-components';
import { lineHeight, theme, toRem } from 'design';
import { Button } from '../Button';

interface IToastContentProps {
  message: string;
  title?: string;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
}

const Layout = styled.div`
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const Content = styled.div`
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: auto;
`;

const Message = styled.p`
  margin: 0;
  font-family: ${theme.font.family.euclid};
  font-weight: ${theme.font.weight.regular};
  font-size: ${toRem(theme.font.size.sm)};
  line-height: ${lineHeight(theme.font.size.sm)};
  color: ${theme.color.neutral[900]};
`;

const Title = styled(Message)`
  margin-bottom: ${toRem(theme.space.xs)};
  font-weight: ${theme.font.weight.semiBold};
`;

const StyledButton = styled(Button)`
  margin-left: ${toRem(theme.space.xl)};
  background-color: ${theme.color.white};
`;

const ToastContent: React.FC<IToastContentProps> = ({ message, title, actionLabel, onAction, className }) => (
  <Layout className={className}>
    <Content>
      {title && <Title>{title}</Title>}
      <Message>{message}</Message>
    </Content>

    {actionLabel && <StyledButton label={actionLabel} type="button" appearance="secondary" size="small" onClick={onAction} />}
  </Layout>
);

export default ToastContent;
